import { ApiError } from './http-client';

export const MAX_RETRY_AFTER_MS = 30_000;

export const isTransientFailure = (error: unknown): error is ApiError =>
  error instanceof ApiError && (error.isNetwork() || error.status === 408 || error.status === 429 || error.isServer());

export const retryQuery = (failureCount: number, error: unknown): boolean => {
  if (!isTransientFailure(error)) return false;
  if (error.isNetwork()) return failureCount < 3;
  if (error.status === 429) {
    return (
      error.retryAfterMs !== undefined && error.retryAfterMs <= MAX_RETRY_AFTER_MS && failureCount < 2
    );
  }
  return failureCount < 2;
};

export const retryQueryDelay = (attempt: number, error: unknown): number => {
  if (error instanceof ApiError && error.retryAfterMs !== undefined) {
    return Math.min(error.retryAfterMs, MAX_RETRY_AFTER_MS);
  }
  return Math.min(1000 * 2 ** attempt, 8000);
};
